import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ChartModel } from 'src/app/models/chart.model';
import { ChartsService } from 'src/app/services/charts.service';
import { ClickStreamService } from 'src/app/services/click-stream.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>, private clickstream : ClickStreamService,
    @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, public chartsService: ChartsService) { }

  charts: ChartModel[] = [];
  externalIds: string[] = [];
  loading: boolean = false;

  ngOnInit(): void {
    this.charts = this.data.charts;
    this.externalIds = this.data.externalIds;
  }

  close() {
    this.dialogRef.close();
    this.clickstream.send('no-button-click', 'click', 'Push ChartModel - Review and Push - Pop Up First Time', 'No Button', '', true);
  }

  save() {
    this.loading = true;
    this.chartsService.pushCharts(this.charts, this.externalIds).subscribe(result => {
      this.loading = false;
      this.router.navigate(['/admin']);
    })
    this.dialogRef.close();
    this.clickstream.send('yes-button-click', 'click', 'Push ChartModel - Review and Push - Pop Up First Time', 'Yes Button', '', true);
  }

}
